const TOKEN_KEY = "lopiy.session";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export async function api(path, options = {}) {
  const headers = {
    ...(options.body ? { "Content-Type": "application/json" } : {}),
    ...options.headers,
  };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  const response = await fetch(path, { ...options, headers });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    if (response.status === 401) setToken("");
    throw new Error(payload.error || "Islem tamamlanamadi.");
  }
  return payload;
}

export async function apiBlob(path) {
  const response = await fetch(path, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!response.ok)
    throw new Error(
      (await response.json().catch(() => ({}))).error || "Dosya indirilemedi.",
    );
  return response.blob();
}

export async function listenToAccessLogs({ schoolId, signal, onOpen, onLog }) {
  const query = new URLSearchParams();
  if (schoolId) query.set("schoolId", schoolId);
  const response = await fetch(`/api/logs/stream?${query}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
    signal,
  });
  if (!response.ok || !response.body)
    throw new Error("Canlı geçiş bağlantısı kurulamadı.");

  onOpen?.();
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (!signal.aborted) {
    const { value, done } = await reader.read();
    if (done) throw new Error("Canlı geçiş bağlantısı kapandı.");
    buffer += decoder.decode(value, { stream: true }).replace(/\r\n/g, "\n");
    let boundary;
    while ((boundary = buffer.indexOf("\n\n")) !== -1) {
      const frame = buffer.slice(0, boundary);
      buffer = buffer.slice(boundary + 2);
      if (!frame || frame.startsWith(":")) continue;
      const event = frame.match(/^event:\s*(.+)$/m)?.[1]?.trim();
      const data = frame.match(/^data:\s*(.+)$/m)?.[1];
      if (event === "access-log" && data) {
        try {
          onLog?.(JSON.parse(data));
        } catch {
          // Ignore malformed frames and keep the live connection open.
        }
      }
    }
  }
}
